import {useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import {useLanguageStore} from "../../store/languageStore";
import {Link} from "react-router-dom";

export default function ProductsSection({data}) {
    const [swiper, setSwiper] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);


    const {language} = useLanguageStore()
    const isArabic = language === 'ar'

    return (
        <div className="w-full py-16 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-12">
                    {isArabic ? 'المنتجات' : 'Products '}
                </h2>

                <div className="relative">
                    <Swiper
                        onSwiper={setSwiper}
                        modules={[Pagination, Navigation, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: true,
                        }}
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}

                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination',
                            bulletClass: 'swiper-pagination-bullet',
                            bulletActiveClass: 'swiper-pagination-bullet-active'
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                            1280: {
                                slidesPerView: 4,
                            },
                        }}
                        className="w-full"
                    >
                        {data.map((product) => (
                            <SwiperSlide key={product.id} className="h-full my-2">
                                <Link to={`/product/${product.id}`}>
                                    <div
                                        className="bg-white rounded-lg shadow-md overflow-hidden h-full flex flex-col p-6"
                                        dir={!isArabic ? 'ltr' : 'rtl'}>
                                        <div className="h-64 flex items-center justify-center mb-6">
                                            <img loading="lazy"
                                                src={product.image}
                                                alt={product.title}
                                                className="h-full object-contain rounded-lg"
                                            />
                                        </div>
                                        <h3 className="text-xl font-semibold text-gray-800 mb-3 line-clamp-1">{isArabic ? product.name_ar : product.name_en}</h3>
                                        <p className="text-gray-600 text-sm line-clamp-2">{isArabic ? product.description_ar : product.description_en}</p>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className="flex justify-center mb-5">
                        <div className="swiper-pagination mt-8 flex justify-center space-x-2">
                            {data.map((_, index) => (
                                <button
                                    key={index}
                                    className={`w-2 h-2 rounded-full bg-gray-300 hover:bg-teal-500 focus:outline-none ${
                                        index === activeIndex ? 'bg-teal-500' : ''
                                    }`}
                                    onClick={() => swiper?.slideTo(index)}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex justify-center mt-20">
                    <Link to={'/products'}>
                        <button
                            className="bg-teal-500 text-white px-10 py-3 rounded-md hover:bg-teal-600 transition-colors duration-300">
                            {isArabic ? 'عرض  الكل' : 'View All '}
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}